export const cardsData = [
  {
    videoSrc: "/assets/videos/chiptunningvideo.mp4",
    imgSrc: "/assets/images/chiptuning1.png",
    title: "STAGE 1 CHIPTUNING",
    buttonLink: "/chip-tuning",
    description:
      "Dit is een softwarematige aanpassing binnen de grenzen van de motor die ervoor zal zorgen dat het voertuig extra vermogen zal krijgen en dat het brandstofgebruik verminderd zal worden (Ongeveer 20% brandstof besparing,....",
  },
  {
    videoSrc: "/assets/videos/chiptunningvideo.mp4",
    // imgSrc: "/assets/videos/chiptunningvideo.mp4",
    title: "STAGE 2 CHIPTUNING",
    buttonLink: "/Chip-Tuning",
    description:
      "Stage 2 is een aanvulling van stage 1. Bij stage 2 gaan wij verder met de ontwikkeling van de software van het voertuig. Bij deze dienst wordt een motoroptimalisatie uitgevoerd en kijken we naar wat uw voertuig nodig heeft. .....",
  },
  {
    videoSrc: "/assets/videos/chiptunningvideo.mp4",
    // imgSrc: "/assets/videos/chiptunningvideo.mp4",
    title: "STAGE 3 CHIPTUNING",
    buttonLink: "/Chip-Tuning",
    description:
      "Deze stage is bedoeld om het uiterste uit uw voertuig te halen. Voor deze service is het noodzakelijk om meerdere aanpassingen aan het voertuig te voorzien.Deze service is dus alleen .....",
  },
  {
    videoSrc: "/assets/videos/popsbangs.mp4",
    // imgSrc: "/assets/videos/popsbangs.mp4",
    title: "POPS & BANGS",
    buttonLink: "/Pops-&-Bangs",
    description:
      "Pops & Bangs heeft zijn naam te danken aan het knallende geluid dat uit de uitlaat komt. Deze service is ook wel bekend als Anti-Lag System (ALS) of als Exhaust Crackle. Bij deze service blijft de turbo in werking wanneer het gaspedaal niet ingedrukt is......",
  },
  {
    videoSrc: "/assets/videos/dpfsolutions1.mp4",
    // imgSrc: "/assets/videos/dpfsolutions.mp4",
    title: "DPF SOLUTIONS",
    buttonLink: "/DPF-Solutions",
    description:
      "DPF ook wel bekend als roetfilter. Dit is een filter die de uitlaatgassen doorlaat en de roetdeeltjes opvangt. Bij hoge temperaturen of lange afstanden start uw voertuig automatisch een regeneratieproces om de roetdeeltjes te verbranden.....",
  },
  {
    videoSrc: "/assets/videos/egrsolutionsvideo.mp4",
    imgSrc: "/assets/images/egrsolutions1.png",
    title: "EGR SOLUTIONS",
    buttonLink: "/EGR-Solutions",
    description:
      "Het EGR (Exhaust Gas Recirculation) systeem zorgt ervoor dat de uitlaatgassen opnieuw de verbrandingskamer in gaan. Door dit proces wordt de temperatuur van de uitlaatgassen verminderd.........",
  },
  {
    videoSrc: "/assets/videos/startstop.mp4",
    // imgSrc: "/assets/videos/startstop.mp4",
    title: "START STOP",
    buttonLink: "/Start-Stop",
    description:
      "De Start Stop functie zorgt ervoor dat de auto automatisch afslaat als uw voertuig tot stilstand komt en automatisch weer start op het moment dat u weer gaat rijden. Dit zorgt ervoor dat de uitstoot van schadelijke stoffen vermindert en.....",
  },
  {
    videoSrc: "/assets/videos/exhaustcontrol1.mp4",
    // imgSrc: "/assets/videos/ecotuningvideo.mp4",
    title: "EXHAUST FLAP CONTROL",
    buttonLink: "/Exhaust-Flap-Control",
    description:
      "Exhaust Flap Control geeft u meer controle over het geluid van uw auto. Vertrek je op een rustige vroege ochtend en wil je niet iedereen om je heen wakker maken of wil je juist jouw aanwezigheid kenbaar maken?.....",
  },
  {
    videoSrc: "/assets/videos/launchcontrol.mp4",
    // imgSrc: "/assets/videos/launchcontrol.mp4",
    title: "LAUNCH CONTROL",
    buttonLink: "/Launch-Control",
    description:
      "Met Launch Control wordt ervoor gezorgd dat uw voertuig vanuit stilstand gemakkelijker de maximale snelheid kan bereiken. Dit heeft te maken met uw koppeling en gaspedaal bij het optrekken van uw voertuig. Bij X-TR.....",
  },
  {
    videoSrc: "/assets/videos/hardrevcut.mp4",
    imgSrc: "/assets/images/hardrevcut1.png",
    title: "HARD REV CUT",
    buttonLink: "/Hard-Rev-Cut",
    description:
      "Bij de meeste auto's is de ECU ontworpen om de acceleratiekracht te verminderen wanneer het toerental de toerenbegrenzer nadert. Dit betekent dat de acceleratie in dit toerentalbereik wordt belemmerd en.......",
  },
  {
    videoSrc: "/assets/videos/dtc1.mp4",
    imgSrc: "/assets/images/dtcremoval1.png",
    title: "DTC REMOVAL",
    buttonLink: "/DTC-Removal",
    description:
      "Bij het verwijderen van de DTC* worden de foutcodes die uw voertuig aangeeft verwijderd. Door deze foutcodes gaat het motorlampje branden in uw voertuig. Dit kan soms voorkomen....",
  },
  {
    videoSrc: "/assets/videos/dsg1.mp4",
    imgSrc: "/assets/images/dsg1.png",
    title: "DSG / AUTOMAAT TUNING",
    buttonLink: "/DSG-Tuning",
    description:
      "DSG* is een manier waarbij een combinatie van automatisch schakelen en koppelen wordt toegepast. Met DSG Tuning kunnen wij het schakelgedrag........",
  },
  {
    videoSrc: "/assets/videos/ecotuningvideo.mp4",
    imgSrc: "/assets/images/eco1.png",
    title: "ECO TUNING",
    buttonLink: "/ECO-Tuning",
    description:
      "Bij Eco Tuning wordt de motor van uw voertuig fijn afgesteld. Er zal hierdoor een betere verbranding in de motor plaatsvinden. Het voertuig maakt.........",
  },
  {
    videoSrc: "/assets/videos/adblue1.mp4",
    // imgSrc: "/assets/videos/adbluesolutions.mp4",
    title: "ADBLUE SOLUTIONS",
    buttonLink: "/Adblue-Solutions",
    description:
      "Adblue wordt gebruikt bij dieselmotoren om deze schoner te laten rijden. De uitstoot van stikstof uit de uitlaat wordt hiermee verminderd. Adblue is te vinden in een afzonderlijke tank op vrachtauto’s, (bestel...",
  },
  {
    videoSrc: "/assets/videos/noxsolutions.mp4",
    // imgSrc: "/assets/videos/noxsolutions.mp4",
    title: "LAMBDASONDE & NOx SOLUTIONS",
    buttonLink: "/Lambdasonde-&-NOx-Solutions",
    description:
      "In de uitlaat van uw auto bevindt zich een sensor dit is de lambdasonde. Deze sensor is te vinden bij zowel benzine als dieselmotoren en meet het aandeel zuurstof in het uitlaatgas. Het kan voorkomen ....",
  },
  {
    videoSrc: "/assets/videos/vmax1.mp4",
    // imgSrc: "/assets/videos/vmax.mp4",
    title: "V-MAX",
    buttonLink: "/V-Max",
    description:
      "V-Max is een snelheidsbegrenzer die in veel voertuigen is geprogrammeerd. In de meeste gevallen zijn deze begrensd op 250 km, hierdoor kunt u niet altijd de topsnelheid van uw auto eruit halen....",
  },
];
